import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import AddJob from "./components/AddJob";
import Navbar from "./components/Navbar";

import './css/DragBox.css';
import './css/index.css';
import './css/Glass.css';
import Auth from "./views/Auth";
import JobDetails from "./views/JobDetails";
import Tracker from "./views/Tracker";
import TrackerDemo from "./Demo/TrackerDemo";
import Demo from "./views/Demo";
import DemoError from "./Demo/DemoError";
import LandingPage from "./components/Landing/LandingPage";
import LandingNav from "./components/navbar/LandingNav";
import Container from "./components/Container";

const App = () => {
  const [isOpen, setIsOpen] = useState(false);
  const getUserFromLS = () => {
    const user = localStorage.getItem('tracker_user');
    if (user){
      return JSON.parse(user)
    }
    return {}
  }
  const [currentUser, setCurrentUser] = useState(getUserFromLS());
  const [columnMap, setColumnMap] = useState({ wishlist: [], applied: [], interviewing: [], offer: [] });
  return (
      <>
        <LandingNav currentUser={currentUser} setCurrentUser={setCurrentUser}/>
        {/* <Navbar isOpen={isOpen} setIsOpen={setIsOpen} currentUser={currentUser} setCurrentUser={setCurrentUser} /> */}
        {isOpen ? <AddJob columnMap={columnMap} currentUser={currentUser} isOpen={isOpen} setIsOpen={setIsOpen} setColumnMap={setColumnMap} /> : null}
        <main className="pt-24">
          <Container>
            <Routes>
              {!currentUser.token?(
                <>
                  <Route path='' element={<LandingPage/>} />
                  <Route path='/connect' element={<Auth setCurrentUser={setCurrentUser}/>} />
                </>  
              ):(
                <>
                  <Route path='' element={<Tracker isOpen={isOpen} setIsOpen={setIsOpen} currentUser={currentUser} columnMap={columnMap} setColumnMap={setColumnMap} />} />
                  <Route path='/jobs/:jobId' element={<JobDetails currentUser={currentUser} />} />
                </>
              )}
              <Route path='/demo/*' element={<DemoError />} />
            </Routes>
          </Container>
        </main>
      </>
    )
};
export default App;
